export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9540.0b0b84c2.jpg";